var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    attrs: {
      "tile": "",
      "elevation": "0"
    }
  }, [_c('v-card-text', {
    staticClass: "pb-0"
  }, [_c('v-layout', {
    attrs: {
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm2": ""
    }
  }, [_vm._v("옵션깊이")]), _c('v-flex', {
    attrs: {
      "grow-shrink-0": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.optionCountItems,
      "item-text": "text",
      "item-value": "value",
      "outlined": "",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.optionCount,
      callback: function ($$v) {
        _vm.optionCount = $$v;
      },
      expression: "optionCount"
    }
  })], 1)], 1)], 1), _c('v-divider', {
    staticClass: "mt-4"
  }), _c('v-card-text', {
    staticClass: "pb-0"
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm2": ""
    }
  }, [_vm._v("옵션입력")]), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": ""
    }
  }, [_c('v-layout', [_c('v-flex', {
    staticClass: "text-center",
    attrs: {
      "xs5": ""
    }
  }, [_vm._v("옵션명")]), _c('v-flex', {
    staticClass: "text-center",
    attrs: {
      "xs5": ""
    }
  }, [_vm._v("옵션값")]), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  })], 1), _c('v-divider', {
    staticClass: "mt-2"
  }), _vm._l(_vm.optionCount, function (i, index) {
    return _c('v-layout', {
      key: index,
      staticClass: "mt-2 mx-n1"
    }, [_c('v-flex', {
      staticClass: "px-1",
      attrs: {
        "xs5": ""
      }
    }, [_c('v-text-field', {
      attrs: {
        "dense": "",
        "hide-details": "",
        "outlined": "",
        "placeholder": _vm.placeholders[index].name
      },
      model: {
        value: _vm.optionGroups[index].name,
        callback: function ($$v) {
          _vm.$set(_vm.optionGroups[index], "name", $$v);
        },
        expression: "optionGroups[index].name"
      }
    })], 1), _c('v-flex', {
      staticClass: "px-1",
      attrs: {
        "xs5": ""
      }
    }, [_c('v-text-field', {
      attrs: {
        "dense": "",
        "hide-details": "",
        "outlined": "",
        "placeholder": _vm.placeholders[index].value
      },
      model: {
        value: _vm.optionGroups[index].value,
        callback: function ($$v) {
          _vm.$set(_vm.optionGroups[index], "value", $$v);
        },
        expression: "optionGroups[index].value"
      }
    })], 1), _c('v-flex', {
      staticClass: "px-1",
      attrs: {
        "xs2": ""
      }
    }, [1 < _vm.optionCount ? _c('v-btn', {
      staticClass: "px-1 mr-1 primary--text",
      staticStyle: {
        "min-width": "auto"
      },
      attrs: {
        "color": "white",
        "width": "36"
      },
      on: {
        "click": function ($event) {
          _vm.optionCount--;
        }
      }
    }, [_c('v-icon', [_vm._v("mdi-minus")])], 1) : _vm._e()], 1)], 1);
  }), _c('v-layout', {
    staticClass: "mt-2 mx-n1"
  }, [_c('v-flex', {
    staticClass: "px-1",
    attrs: {
      "xs10": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "width": "100%",
      "color": "primary",
      "dark": ""
    },
    on: {
      "click": function ($event) {
        return _vm.generate();
      }
    }
  }, [_vm._v("옵션목록으로 적용"), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-chevron-down")])], 1)], 1), _c('v-flex', {
    staticClass: "px-1",
    attrs: {
      "xs2": ""
    }
  }, [_vm.optionCount < _vm.optionCountItems.length ? _c('v-btn', {
    staticClass: "px-1",
    staticStyle: {
      "min-width": "auto"
    },
    attrs: {
      "width": "36",
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        _vm.optionCount++;
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-plus")])], 1) : _vm._e()], 1)], 1)], 2)], 1)], 1), _c('v-divider', {
    staticClass: "mt-4"
  }), _c('v-card-text', {
    staticClass: "pb-0"
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm2": ""
    }
  }, [_vm._v("옵션목록")]), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": ""
    }
  }, [_c('v-layout', {
    staticClass: "mx-n1"
  }, [_c('v-spacer'), _c('v-flex', {
    staticClass: "px-1"
  }, [_c('v-select', {
    staticClass: "text-center",
    attrs: {
      "items": _vm.operatorItems,
      "label": "연산자",
      "persistent-placeholder": "",
      "dense": "",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.header.operator,
      callback: function ($$v) {
        _vm.$set(_vm.header, "operator", $$v);
      },
      expression: "header.operator"
    }
  })], 1), _c('v-flex', {
    staticClass: "px-1"
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "label": "판매가",
      "persistent-placeholder": "",
      "dense": "",
      "outlined": "",
      "hide-details": ""
    },
    on: {
      "input": function ($event) {
        _vm.header.salePrice = _vm.header.salePrice.replace(/[^0-9]/, '');
      }
    },
    model: {
      value: _vm.header.salePrice,
      callback: function ($$v) {
        _vm.$set(_vm.header, "salePrice", $$v);
      },
      expression: "header.salePrice"
    }
  })], 1), _c('v-flex', {
    staticClass: "px-1"
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "label": "추가값",
      "persistent-placeholder": "",
      "dense": "",
      "outlined": "",
      "hide-details": ""
    },
    on: {
      "input": function ($event) {
        _vm.header.addPrice = _vm.header.addPrice.replace(/[^0-9]/, '');
      }
    },
    model: {
      value: _vm.header.addPrice,
      callback: function ($$v) {
        _vm.$set(_vm.header, "addPrice", $$v);
      },
      expression: "header.addPrice"
    }
  })], 1), _c('v-flex', {
    staticClass: "px-1"
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "label": "재고수량",
      "persistent-placeholder": "",
      "dense": "",
      "outlined": "",
      "hide-details": ""
    },
    on: {
      "input": function ($event) {
        _vm.header.stock = _vm.header.stock.replace(/[^0-9]/, '');
      }
    },
    model: {
      value: _vm.header.stock,
      callback: function ($$v) {
        _vm.$set(_vm.header, "stock", $$v);
      },
      expression: "header.stock"
    }
  })], 1), _c('v-flex', {
    staticClass: "px-1",
    attrs: {
      "xs2": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "small": "",
      "height": "40"
    },
    on: {
      "click": _vm.batch
    }
  }, [_vm._v("선택목록 일괄수정")])], 1)], 1), _c('v-divider', {
    staticClass: "mt-2"
  }), _c('v-data-table', {
    staticClass: "mt-2",
    attrs: {
      "headers": _vm.optionalProductsHeaders,
      "items": _vm.optionalProducts.filter(function (option) {
        return !option.isDeleted;
      }),
      "item-key": "optionalValues",
      "show-select": ""
    },
    scopedSlots: _vm._u([{
      key: "item.value",
      fn: function (_ref) {
        var item = _ref.item;
        return _c('v-layout', {}, _vm._l(item.optionalValues, function (optionalValue, index) {
          return _c('v-flex', {
            key: index,
            staticClass: "pa-0"
          }, [_vm._v(_vm._s(optionalValue))]);
        }), 1);
      }
    }, {
      key: "item.salePrice",
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_c('v-text-field', {
          staticClass: "text-center",
          attrs: {
            "type": "number",
            "dense": "",
            "hide-details": ""
          },
          model: {
            value: item.salePrice,
            callback: function ($$v) {
              _vm.$set(item, "salePrice", $$v);
            },
            expression: "item.salePrice"
          }
        })];
      }
    }, {
      key: "item.addPrice",
      fn: function (_ref3) {
        var item = _ref3.item;
        return [_c('v-text-field', {
          staticClass: "text-center",
          attrs: {
            "type": "number",
            "dense": "",
            "hide-details": ""
          },
          model: {
            value: item.addPrice,
            callback: function ($$v) {
              _vm.$set(item, "addPrice", $$v);
            },
            expression: "item.addPrice"
          }
        })];
      }
    }, {
      key: "item.stock",
      fn: function (_ref4) {
        var item = _ref4.item;
        return [_c('v-text-field', {
          staticClass: "text-center",
          attrs: {
            "type": "number",
            "dense": "",
            "hide-details": ""
          },
          model: {
            value: item.stock,
            callback: function ($$v) {
              _vm.$set(item, "stock", $$v);
            },
            expression: "item.stock"
          }
        })];
      }
    }, {
      key: "item.actions",
      fn: function (_ref5) {
        var item = _ref5.item,
          index = _ref5.index;
        return [_c('v-icon', {
          attrs: {
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.remove(item, index);
            }
          }
        }, [_vm._v("mdi-delete")])];
      }
    }]),
    model: {
      value: _vm.selected,
      callback: function ($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  }, [_c('template', {
    slot: "header.optionalValues"
  }, [_c('v-layout', [_c('v-flex', [_vm._v("옵션명")])], 1), _vm.optionalNames.length ? _c('v-divider', {
    staticClass: "my-1"
  }) : _vm._e(), _vm.optionalNames.length ? _c('v-layout', _vm._l(_vm.optionalNames, function (optionalName, index) {
    return _c('v-flex', {
      key: index
    }, [_vm._v(_vm._s(optionalName))]);
  }), 1) : _vm._e()], 1)], 2)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }